export default "__VITE_ASSET__7f52fcf5__"